// redux
import { configureStore } from "@reduxjs/toolkit";
// reducers
import shellReducer from "../shell/shellSlice";
import nopimsBasketReducer from "../nopims/basket/nopimsBasketSlice";
// middleware
import { listenerMiddleware } from "./listenerMiddleware";

const store = configureStore({
    reducer: {
        shell: shellReducer,
        nopimsBasket: nopimsBasketReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

//show initialised state
// console.log(store.getState());

export default store;
